"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LightThemeMove = void 0;

var _creator = _interopRequireDefault(require("./creator.js"));

var _lightThemePrimitives = require("./light-theme-primitives.js");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var primaryFontFamily = 'UberMoveText, system-ui, "Helvetica Neue", Helvetica, Arial, sans-serif';
var secondaryFontFamily = 'UberMove, UberMoveText, system-ui, "Helvetica Neue", Helvetica, Arial, sans-serif';
var LightThemeMove = (0, _creator.default)(_objectSpread({}, _lightThemePrimitives.primitives, {
  primaryFontFamily: primaryFontFamily
}), {
  name: 'light-theme-with-move',
  typography: {
    font250: {
      fontWeight: 500
    },
    font350: {
      fontWeight: 500
    },
    font450: {
      fontWeight: 500
    },
    font500: {
      fontWeight: 500
    },
    font600: {
      fontWeight: 500
    },
    font700: {
      fontWeight: 500
    },
    font800: {
      fontWeight: 500
    },
    font900: {
      fontWeight: 500
    },
    font1100: {
      fontFamily: secondaryFontFamily
    }
  }
});
exports.LightThemeMove = LightThemeMove;